import React from "react";
import { Modal, Button } from "react-bootstrap";
import { useTranslation } from "react-i18next";

/**
 * Reusable AlertDialog component
 * @param {Object} props - Component props
 * @param {boolean} props.show - Controls the visibility of the dialog
 * @param {string} props.title - Title of the dialog
 * @param {string} props.message - Message content of the dialog
 * @param {string} [props.confirmText='OK'] - Text for the confirm button
 * @param {string} [props.confirmVariant='primary'] - Bootstrap variant for the confirm button
 * @param {boolean} [props.showCancel=false] - Whether to show the cancel button
 * @param {string} [props.cancelText='Cancel'] - Text for the cancel button
 * @param {Function} props.onConfirm - Callback when confirm button is clicked
 * @param {Function} props.onCancel - Callback when cancel button is clicked or dialog is closed
 * @param {string} [props.size='md'] - Size of the modal ('sm', 'md', 'lg', 'xl')
 * @returns {JSX.Element} AlertDialog component
 */
const AlertDialog = ({
  show,
  title,
  message,
  confirmText,
  confirmVariant = "primary",
  showCancel = false,
  cancelText,
  onConfirm,
  onCancel,
  size = "md",
}) => {
  const { t } = useTranslation();

  return (
    <Modal
      show={show}
      onHide={onCancel}
      centered
      size={size}
      className="motor-modal"
    >
      <Modal.Header closeButton>
        <Modal.Title>{title}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div dangerouslySetInnerHTML={{ __html: message }} />
      </Modal.Body>
      <Modal.Footer>
        {showCancel && (
          <Button variant="secondary" onClick={onCancel}>
            {cancelText || t("cancel")}
          </Button>
        )}
        <Button
          variant={confirmVariant}
          onClick={onConfirm}
          className="btn h-btn"
          style={{ minWidth: "50px" }}
        >
          {confirmText || t("ok")}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default AlertDialog;
